import { CardContent, Typography, Button } from "@mui/material";
import {
  useGetResourceLabel,
  useTranslate,
  useResourceContext,
} from "react-admin";

import { useTypedListContext } from "@/hooks";

interface ListNoResultsProps {
  defaultFilters?: Record<string, unknown>;
}

export const ListNoResultsWithFilters = (props: ListNoResultsProps) => {
  const translate = useTranslate();
  const resource = useResourceContext();
  const { filterValues, setFilters } = useTypedListContext();
  const getResourceLabel = useGetResourceLabel();
  if (!resource) {
    throw new Error("<ListNoResults> must be used inside a <List> component");
  }
  return (
    <CardContent>
      <Typography variant="body2">
        {Object.keys(filterValues).length > 0 ? (
          <>
            {translate("ra.navigation.no_filtered_results", {
              resource,
              name: getResourceLabel(resource, 0),
              _: "No results found with the current filters.",
            })}{" "}
            <Button onClick={() => setFilters(props.defaultFilters || {}, [])}>
              {translate("ra.navigation.clear_filters", {
                _: "Clear filters",
              })}
            </Button>
          </>
        ) : (
          translate("ra.navigation.no_results", {
            resource,
            name: getResourceLabel(resource, 0),
            _: "No results found.",
          })
        )}
      </Typography>
    </CardContent>
  );
};
